import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import qs from "qs";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { TeamFilter } from "./TeamFilter";
import { TeamList } from "./TeamList";
import { InviteOrganizationUserDialog } from "./InviteOrganizationUserDialog";
import { OrganizationUserDialog } from "./OrganizationUserDialog";

export const Team: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tab, id: organizationUserId } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string };

  const handleClickMember = (id: string) => {
    searchParams.set("tab", "details");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleInvite = () => {
    searchParams.set("tab", "invite");
    setSearchParams(searchParams);
  };

  const handleCloseInviteDialog = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
  };

  const handleCloseMemberDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <TeamFilter onInvite={handleInvite} />
        <TeamList onClickItem={handleClickMember} />
      </Stack>

      <InviteOrganizationUserDialog
        open={tab === "invite"}
        onClose={handleCloseInviteDialog}
        onCompleted={handleCloseInviteDialog}
      />

      <OrganizationUserDialog
        open={tab === "details"}
        organizationUserId={organizationUserId ?? null}
        onClose={handleCloseMemberDialog}
      />
    </FilterProvider>
  );
};
